<template>
    <section class="section__present">
        <h1>Fastest</h1>
        <span class="text__span1">Delivery</span>
        <h1>In ShopT 2.0</h1>
        <span class="text__span2">Prices as low as 0.59 USD.</span>
    </section>
</template>

<script>
export default {
    name: 'Presentation'
}
</script>

<style scoped>
    .section__present {
        padding: 15rem 0 22rem;
    }

    .section__present h1 {
        color: #fff;
        font-size: 3rem;
        text-transform: uppercase;
        font-weight: 900;
    }

    .section__present .text__span1 {
        text-transform: uppercase;
        font-size: 2.2rem;
        padding: 0 8px;
        background-color: #4ec7f3;
    }

    .section__present .text__span2 {
        color: #fff;
    }

    #fireworks {
        padding-top: 5rem;
        padding-bottom: 5rem;
    }
</style>
